<template>
  <div id="app">
    <div class="top">
      <div class="nav">
        <div class="container">
          <div class="row">
            <div class="col-md-2 col-xs-6">
              <img class="logo" src="./assets/Logo.svg" alt="" />
            </div>
            <div class="col-md-8 text-center hidden-xs">
              <ul class="menu">
                <li><a href="#course">О курсe</a></li>
                <li><a href="#lessons">Программа</a></li>
                <li><a href="#about">Инструктор</a></li>
                <li><a href="#prices">Цены</a></li>
              </ul>
            </div>
            <div class="col-md-2 text-right col-xs-6">
              <a class="ybutton" href="#prices">Купить</a>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="container">
        <div class="row">
          <div class="col-md-12">header</div>
        </div>
      </div> -->

      <div class="big-header">
        <div class="big-text">
          <span
            ><span class="thick">S</span>амый
            <span class="highlight">полный</span>
            <span class="blurple">ETF</span> курс</span
          ><sup class="purple">Версия 2.0 доступна с 03.01.22</sup>
        </div>
      </div>

      <div class="break"></div>

      <div class="container">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <h1>
              ETF - <strong>лучший</strong> инструмент для формирования капитала
            </h1>
            <p>
              ETF - это инвестиционный инструмент, позволяющий покупать готовые
              “корзины” акций разных регионов, типов и стилей.
            </p>
            <div class="break40"></div>
          </div>
          <div class="col-md-6">
            <div class="etf-wrapper">
              <div class="module">
                <div class="etf-block">
                  <table class="etfblock">
                    <tr>
                      <th class="fund">
                        ARKK
                        <span class="subtable">ARK Innovation ETF</span>
                      </th>
                      <th class="fund-price">$129.16</th>
                      <th class="profit">+72.35%</th>
                    </tr>
                    <tr class="smaller">
                      <th class="text-left">Компания:</th>
                      <th></th>
                      <th class="weight">Вес:</th>
                    </tr>
                    <tr>
                      <td>Tesla</td>
                      <td></td>
                      <td>9.58 %</td>
                    </tr>
                    <tr>
                      <td>Roku</td>
                      <td></td>
                      <td>6.22 %</td>
                    </tr>
                    <tr>
                      <td>Teledoc</td>
                      <td></td>
                      <td>5.94 %</td>
                    </tr>
                    <tr>
                      <td>Square</td>
                      <td></td>
                      <td>4.46 %</td>
                    </tr>
                    <tr>
                      <td>Zoom</td>
                      <td></td>
                      <td>4.45 %</td>
                    </tr>
                    <tr>
                      <td>Shopify</td>
                      <td></td>
                      <td>4.34 %</td>
                    </tr>
                    <tr>
                      <td>Twilio</td>
                      <td></td>
                      <td>3.72 %</td>
                    </tr>
                    <tr>
                      <td>Coinbase</td>
                      <td></td>
                      <td>3.68 %</td>
                    </tr>
                    <tr>
                      <td>Остальное</td>
                      <td></td>
                      <td>...</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="text-center">
                <span class="comment mt20"
                  >Пример ETF-а
                  <img src="./assets/arrow.svg" class="arrow" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="heading">
              <h1>
                <span class="blurplee">ETF</span> подходят любому инвестору
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="ybox">
              <h3>Хотите пассивно создавать капитал?</h3>
              <p>
                Выбирайте ETF на США, Китай, развивающиеся рынки или даже на
                весь мир.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="ybox">
              <h3>Хотите более высокий доход и риск?</h3>
              <p>
                Здесь на выбор целый список тематических, инверсионных и даже
                маржинальных ETF.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="ybox">
              <h3>Нет времени на инвестиции?</h3>
              <p>
                Автоматизируйте весь процесс, уделяя инвестированию не более 5
                минут в месяц.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="heading">
              <h1>
                Добро пожаловать в <span class="blurplee">большой</span> мир ETF
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div class="stripe">
        <div class="break"></div>

        <div class="line-holder">
          <div class="line1">
            <div class="fbox" v-for="etf in etfs.line1" :key="etf">
              {{ etf }}
            </div>
          </div>

          <div class="line2">
            <div class="fbox" v-for="etf in etfs.line2" :key="etf">
              {{ etf }}
            </div>
          </div>

          <div class="line3">
            <div class="fbox" v-for="etf in etfs.line3" :key="etf">
              {{ etf }}
            </div>
          </div>
        </div>
        <div class="break25"></div>

        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <span class="comment">…их много, более 7600 по всему миру</span>
            </div>
          </div>
        </div>
      </div>

      <div class="break"></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="heading">
            <h1>
              Инвестируйте напрямую в <br />
              <span class="blurplee">перспективные</span> отрасли
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div class="break25"></div>

    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <ul class="list">
            <li
              v-for="(item, i) in items"
              :key="i"
              :class="{ selected: i === activeItem }"
              @click="selectItem(i)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="col-md-7">
          <div class="break25"></div>
          <div class="">
            <span class="note"
              >{{ items[activeItem].name }}, иллюстративный ETF:</span
            >
          </div>
          <div class="break25"></div>
          <div class="piechart">
            <apexchart
              type="pie"
              width="500"
              :options="items[activeItem].chartOptions"
              :series="items[activeItem].series"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <div class="break"></div>

    <div class="middle" id="course">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="mid-header">
              <div class="mid-text text-center">
                <span
                  ><span>О</span> <span class="highlight">курсе</span> <br />
                  <span class="blurple">ETF PRO 2.0</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="break"></div>
          <div class="col-md-4">
            <div class="wbox">
              <h2 class="text-center">Практично</h2>
              <p>
                Вся информация основана на
                <span class="blurple">практических знаниях</span> и подкреплена
                расчетами.
              </p>
              <p>
                Вы <span class="blurple">сами научитесь</span> оценивать
                привлекательность любого ETF для своего портфеля, рассчитывать
                ожидаемую доходность и риск с помощью подготовленных шаблонов и
                формул и <span class="blurple">будете </span>
                <span class="blurple">уверены</span> в правильности своих
                решений.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="wbox">
              <h2 class="text-center">Реалистично</h2>
              <p>
                Сейчас <span class="blurple">у каждого</span> человека есть
                возможность инвестировать с небольших сумм и формировать свою
                собственную <span class="blurple">пенсию</span>,
                <span class="blurple">финансовую независимость</span> или
                создавать <span class="blurple">капитал для детей</span>.
              </p>
              <p>Не воспользоваться этой возможностью просто нельзя!</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="wbox">
              <h2 class="text-center">Доступно</h2>
              <p>
                <span class="blurple">Все знания</span> для составления портфеля
                и его дальнейшего ведения вы получите на этом четырех-недельном
                практическом курсе.
              </p>
              <p>
                Сложные концепции объяснены
                <span class="blurple">простым языком</span> в 20-минутных
                видео-роликах. Всегда есть возможность задать вопрос.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="heading" style="text-align: center !important">
              <h1>
                Статистика
                <span class="highlight">прошлого</span> потока:
              </h1>
              <br />
              <h3>
                <span class="blurplee">91%</span> составили ETF портфель по
                окончанию курса
              </h3>
              <h3>
                <span class="blurplee">93%</span> студентов оценили полезность
                информации на 5/5 и <span class="blurplee">7%</span> на 4/5
              </h3>
              <h3>
                <span class="blurplee">79%</span> студентов оценили понятность
                уроков 5/5 и <span class="blurplee">21%</span> на 4/5
              </h3>
              <h3>
                Для <span class="blurplee">67%</span> опрошенных курс превзошел
                ожидания и для <span class="blurplee">33%</span> полностью
                соответствовал
              </h3>
              <h3>
                Для <span class="blurplee">60%</span> оопрошенных курс оценен
                оптимально и для <span class="blurplee">40%</span> стоит дешево
              </h3>
              <h2>И...</h2>
              <h3>
                <span class="blurplee">93%</span> готовы порекомендовать этот
                курс друзьям
              </h3>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="heading" style="text-align: center !important">
              <h1>
                Отызвы
                <span class="highlight">прошлого</span> потока:
              </h1>
              <br />
            </div>
          </div>

          <div class="col-md-6 comments">
            <h3 class="text-center">Что понравилось на курсе больше всего?</h3>
            <div class="col-md-6">
              <div class="wbox">
                <p>все понравилось</p>
              </div>
              <div class="wbox">
                <p>Ваш профессионализм</p>
              </div>
              <div class="wbox">
                <p>Подробность и практическая информация</p>
              </div>
              <div class="wbox">
                <p>
                  Практическая информация, без воды, все по делу, в интернете
                  такого нет
                </p>
              </div>
              <div class="wbox">
                <p>
                  практические советы, ссылки на ресурсы, методология расчета
                  показателей, функционал Excel
                </p>
              </div>
              <div class="wbox">
                <p>Разбор портфелей с рекомендациями по разным профилям</p>
              </div>
              <div class="wbox">
                <p>
                  То что Юля доносит сложную информацию простым и доступным
                  языком! Так что даже таким совсем зеленым новичкам как я все
                  понятно! Ну и конечно же то что Юля всегда на связи и отвечает
                  на любой даже самый глупый вопрос! Хотя говорят что глупых
                  вопросов не бывает;)
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="wbox">
                <p>
                  Глубокое раскрытие темы, то что доступ к лекциям не будет
                  закрыт !
                </p>
              </div>
              <div class="wbox">
                <p>
                  Таблички с расчетами. хоть и сложно, но разобравшись многое
                  становится понятным
                </p>
              </div>
              <div class="wbox">
                <p>
                  Курс понравился! Не ожидала такого разнообразия ETF, такое
                  впечатление, что в эту оболочку завернули и инструменты и
                  портфели.
                </p>
              </div>
              <div class="wbox">
                <p>Про стратегии (ядро, качели и тд.)</p>
              </div>
              <div class="wbox">
                <p>
                  Что вы разбирали домашние задания, отвечали на вопросы, что
                  доступ остаётся- мне нужно еще раз все пересмотреть все уроки.
                </p>
              </div>
              <div class="wbox">
                <p>Расчеты корреляций и ковариаций</p>
              </div>
              <div class="wbox">
                <p>Все:лекции,скринеры,таблички</p>
              </div>
              <div class="wbox">
                <p>
                  что вы показали свой портфель и дали примеры реальных
                  иностранных фондов, а не только замыленные фонды России
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-6 comments">
            <h3 class="text-center">
              Что самое главное, что Вы вынесли из пройденного материала?
            </h3>
            <div class="col-md-6">
              <div class="wbox">
                <p>
                  Методы оценки портфеля, статистические методы, проверка
                  портфеля с помощью сторонних сервисов
                </p>
              </div>
              <div class="wbox">
                <p>
                  Про СЧА, стоимость управления, сравнение фондов и
                  диверсификацию
                </p>
              </div>
              <div class="wbox">
                <p>инвестировать действительно просто</p>
              </div>
              <div class="wbox">
                <p>Принципы анализа ETF и составления портфеля</p>
              </div>
              <div class="wbox">
                <p>В инвестировании ничего страшного нет - надо начинать.</p>
              </div>
              <div class="wbox">
                <p>
                  Надо не бояться, действовать! Открывать счёт, покупать ETF по
                  своей инвестиционнной стратегии!
                </p>
              </div>
              <div class="wbox">
                <p>что мне очень понравилось анализировать !!</p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="wbox">
                <p>Надо диверсифицировать даже ЕТФ</p>
              </div>
              <div class="wbox">
                <p>я могу инвестировать сам</p>
              </div>
              <div class="wbox">
                <p>
                  Желание открыть счёт у иностранного брокера и составить
                  портфель из ETF.
                </p>
              </div>
              <div class="wbox">
                <p>Что некоторые ETF не стоит держать по 20 лет)</p>
              </div>
              <div class="wbox">
                <p>
                  Что хочу у вас учиться инвестированию и пройти другие курсы
                </p>
              </div>
              <div class="wbox">
                <p>
                  Узнала что такое ETF, как составить портфель и
                  проанализировать доходность
                </p>
              </div>
              <div class="wbox">
                <p>Инвестиции в фонды-отличная стратегия</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="heading" style="text-align: center !important">
              <h1>
                Изменения во 2-ом потоке
                <span class="highlight">исходя</span> из обратной связи:
              </h1>
              <br />
            </div>
          </div>
          <div class="col-md-3 text-center"></div>
        </div>

        <badger-accordion>
          <badger-accordion-item>
            <template slot="header">
              <div style="text-align: center">
                <span
                  style="
                    display: inline-block;
                    background-color: #8070e1;
                    padding: 10px 20px;
                    border-radius: 8px;
                    color: white;
                  "
                  >Читать детальнее...</span
                ><br /></div
            ></template>
            <template slot="content">
              <br />
              <br />
              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    Для меня было тяжело составление Excel первой таблицы. Может
                    можно сделать калькулятор для одного фонда с формулами.
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    К сожалению при расчетах доходности и риска портфеля
                    необходимо иметь данные корреляции по всем фондам и без
                    матрицы ковариации не обойтись. Из позитивного - в ней
                    используется всего одна формула :). При составлении портфеля
                    из одного фонда, конечно же, ничего считать не нужно.
                  </p>
                  <p>
                    Для облегчения понимания информации во
                    <strong
                      >2-ом потоке будут сделаны краткие памятки по этим
                      формулам.</strong
                    >
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>таблички в экселе)</p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>без них курс будет лишь теорией</p>
                  <p>
                    Для облегчения понимания информации во 2-ом потоке будут
                    сделаны краткие памятки по этим формулам.
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    для налоговых резидентов России было бы здорово получить
                    больше информации по бПИФ, торгующихся на Московской биржи
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    бПИФ анализируется по тем же правилам, что и ETF, но по нему
                    меньше информации в публичных источниках.
                  </p>
                  <p>
                    <strong>
                      Во 2-ом потоке будет дополнительный вебинар по бПИФ
                    </strong>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    Все понравилось! Особенно обратная связь! Но можно было бы
                    еще дополнительно сделать один урок как открыть счёт И.Б. из
                    России . Для таких зеленых новичков как я ;)
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    К этому уроку мы дали бесплатный доступ всем участникам
                    курса
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    Курс очень понравился, ничего нет что не понравилось.
                    Возможно в финальном вебинаре не 2 портфеля выбирать, а
                    короткие комментарии по каждому ( тк участников не много)
                    или из портфелей всех участников прокомментировать
                    повторяющиеся или наиболее интересные етф.
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    На финальном разборе мы рассматриваем не просто ETF, а
                    портфель в целом на предмет соответствия риск-профилю и
                    заявленным целям. Разбор одного портфеля занимает от 2-ух
                    часов, в зависимости от качества присланной информации.
                    Короткие комментарии по портфелю не дадут объективной
                    картины. Но во
                    <strong
                      >2-ом потоке мы дадим несколько готовых портфелей для
                      разных регионов и риск-профилей</strong
                    >
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    Больше про работу и устройство фондов, как работает валютный
                    хэдж (как технически и физически он реализован), как и в
                    каких ситуациях покупки и продажи ценных бумаг фондами
                    влияют на цены этих бумаг на рынке и т.д.
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    <strong
                      >Во 2-ом потоке добавим два новых видео: 1. Как работает
                      валютный хедж 2. Как покупки и продажи ETF влияют на
                      ценные бумаги
                    </strong>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>хочу чтобы сказали, что купить !! (шучу)</p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>😂 Во 2-ом потоке будет видео от трендах 2022</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 text-left cursive">
                  <p>
                    сделать тариф с проверкой домашек, иначи нет мотивации их
                    делать
                  </p>
                </div>
                <div class="col-md-6 text-left reply">
                  <p>
                    Будет! :)<br />
                    Во 2-ом потоке будет дополнительный тариф с проверкой
                    домашних заданий
                  </p>
                </div>
              </div>
            </template>
          </badger-accordion-item>
        </badger-accordion>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="heading" style="text-align: center !important">
              <h1>
                Итого в
                <span class="blurple">версии 2.0</span>:
              </h1>
              <br />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-md-push-4">
            <p>
              <span class="blurple">+ </span>
              <strong>Дополнительный вебинар</strong> по бПИФ
            </p>
            <p>
              <span class="blurple">+</span>
              <strong> Несколько готовых портфелей</strong> для разных регионов
              и риск-профилей
            </p>
            <p>
              <span class="blurple">+</span> <strong> Два новых видео:</strong
              ><br />
              Как работает валютный хедж<br />
              Как покупки и продажи ETF влияют на ценные бумаги
            </p>
            <p>
              <span class="blurple">+ </span>
              <strong>Дополнительный тариф</strong> с проверкой домашних заданий
            </p>
            <p>
              <span class="blurple">+</span> <strong>Разбор ETF</strong> на
              криптовалюту
            </p>
            <p>
              <span class="blurple">+</span> <strong>Прогноз:</strong> куда
              инвестировать в 2022 году
            </p>
          </div>
        </div>
      </div>

      <br /><br />

      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <span class="comment"
              >Посчитайте, сколько можно заработать, если регулярно</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="heading notop">
              <h1>
                Инвестировать

                <select v-model="sum" class="select">
                  <option>25</option>
                  <option>50</option>
                  <option>100</option>
                  <option>150</option>
                  <option>200</option>
                  <option>300</option>
                  <option>500</option>
                  <option>1000</option>
                </select>
                <!-- <span class="select"> евро</span> каждый месяц в течение -->
                <span> долларов</span> каждый месяц в течение
                <select v-model="years" class="select">
                  <option>5</option>
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                </select>
                <span>лет</span>
                под
                <select v-model="percent" class="select">
                  <option>8</option>
                  <option>10</option>
                  <option>12</option>
                  <option>14</option>
                  <option>16</option>
                  <option>18</option>
                </select>
                % интресса
              </h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="chart">
              <div id="chart">
                <apexchart
                  type="bar"
                  height="350"
                  :options="getopts"
                  :series="getbars"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <div class="bbox">
              <div class="green-result">${{ (sum * years * 12) | pretty }}</div>
              <div class="desc-result">Вложенная сумма за весь период</div>
            </div>
            <div class="bbox">
              <div class="green-result">${{ intres | pretty }}</div>
              <div class="desc-result">Заработанный интресс</div>
            </div>
            <div class="bbox">
              <div class="green-result">${{ result | pretty }}</div>
              <div class="desc-result">Капитал через {{ years }} лет</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="comment">* историческая доходность рынка США 8-12%</div>
          </div>
        </div>
      </div>

      <div class="break"></div>

      <div class="container" id="lessons">
        <div class="row">
          <div class="col-md-6">
            <h1 class="text-center">Чему вы научитесь</h1>

            <table class="points">
              <tbody>
                <tr>
                  <td>👉</td>
                  <td>Выбирать, оценивать и анализировать ETF</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>
                    Находить и самостоятельно рассчитывать необходимые данные
                  </td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Составлять успешный портфель</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Диверсифицировать риски</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Рассчитывать доходность портфеля</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Выбирать стратегии инвестирования</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Оценивать здоровье портфеля</td>
                </tr>
                <tr>
                  <td>👉</td>
                  <td>Правильно ребалансировать портфель</td>
                </tr>
              </tbody>
            </table>

            <!-- <ul class="learn">
              <li>Выбирать, оценивать и анализировать ETF</li>
              <li>Находить и самостоятельно рассчитывать необходимые данные</li>
              <li>Составлять успешный портфель</li>
              <li>Диверсифицировать риски</li>
              <li>Рассчитывать доходность портфеля</li>
              <li>Выбирать стратегии инвестирования</li>
              <li>Оценивать здоровье портфеля</li>
              <li>Правильно ребалансировать портфель</li>
            </ul> -->
            <div class="break40"></div>
          </div>
          <div class="col-md-6">
            <h1 class="text-center">Учебный план</h1>
            <div class="cal-wrapper">
              <badger-accordion>
                <badger-accordion-item>
                  <template slot="header"
                    >1. Основы и главные принципы ETF</template
                  >
                  <template slot="content">
                    <div class="date">03.01.22</div>
                    <p>
                      1) Что такое ETF (основные отличия от других инструментов,
                      механика работы и результативность)
                    </p>
                    <p>
                      2) Примеры использования ETF в инвестициях (кем и в каких
                      целях чаще всего используются ETF)
                    </p>

                    <p class="i">
                      По результатам этого урока вы будете понимать, что такое
                      ETF, ПИФ и индексный фонд, и как они могут быть
                      использованы в вашем портфеле.
                    </p>

                    <p class="u">ДЗ: контрольный тест</p>
                  </template>
                </badger-accordion-item>

                <badger-accordion-item>
                  <template slot="header"
                    >2. Стратегии инвестирования в ETF</template
                  >
                  <template slot="content">
                    <div class="date">06.01.22</div>
                    <p>1) Стили, типы и классы ETF</p>
                    <p>2) Стратегии инвестирования ETF</p>
                    <p>3) Расчеты доходности и риска составленной стратегии</p>

                    <p class="i">
                      По результатам этого урока вы научитесь подбирать ETF под
                      разные стратегии, рассчитывать доходность и риск выбранной
                      стратегии и принимать инвестиционные решения на основе
                      полученных данных.
                    </p>

                    <p class="u">
                      ДЗ: Самостоятельно просчитать риск предложенной стратегии
                    </p></template
                  >
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header">3. Анализ ETF</template>
                  <template slot="content">
                    <div class="date">10.01.22</div>
                    <p>
                      1) Квантитативные факторы (цифры, на которые надо
                      смотреть)
                    </p>
                    <p>
                      2) Качественные методы (информация, помогающая определить
                      привлекательность ETF)
                    </p>
                    <p>3) Как работает валютный хедж</p>

                    <p>3) Как покупки и продажи ETF влияют на ценные бумаги</p>

                    <p class="i">
                      По результатам этого урока вы сможете самостоятельно
                      проанализировать качество любого ETF и определить,
                      подходит ли он в ваш портфель.
                    </p>

                    <p class="u">
                      ДЗ: Проанализировать два предложенных ETF
                    </p></template
                  >
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header"
                    >4. Обзор и особенности доступных ETF в России и в
                    Европе</template
                  >
                  <template slot="content">
                    <div class="date">17.01.22</div>
                    <p>1) ETF для российского инвестора</p>
                    <p>2) ETF для европейского инвестора</p>
                    <p>3) Особенности инвестирования в ETF в Эстонии</p>
                    <p>4) Разбор фондов на криптовалюту</p>

                    <p class="i">
                      По результатам этого урока вы научитесь находить доступные
                      вам ETF и их альтернативы.
                    </p>
                  </template>
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header">5. Составление портфеля</template>
                  <template slot="content">
                    <div class="date">20.01.22</div>
                    <p>1) Определение своих целей и риск-профиля</p>
                    <p>2) Правила составления портфеля из ETF</p>
                    <p>3) Составление портфеля (Excel template)</p>
                    <p>4) Примеры готовых портфелей</p>

                    <p class="i">
                      По результатам этого урока вы сможете самостоятельно
                      составить свой портфель со всеми необходимыми расчетами.
                    </p>
                    <p class="u">ДЗ: Составить свой портфель</p>
                  </template>
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header"
                    >6. Отслеживание и ребалансировка</template
                  >
                  <template slot="content">
                    <div class="date">24.01.22</div>
                    <p>1) Как понять, что с портфелем все хорошо</p>
                    <p>2) Как и когда ребалансировать</p>
                    <p>3) Когда продавать</p>

                    <p class="i">
                      По результатам этого урока вы будете знать что делать с
                      портфелем через год, пять или десять лет, стоит ли его
                      ребалансировать и как выводить доход.
                    </p>
                  </template>
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header">7. Выпускной</template>
                  <template slot="content">
                    <div class="date">03.02.22</div>
                    <p>Заключительный вебинар</p>
                  </template>
                </badger-accordion-item>
                <badger-accordion-item>
                  <template slot="header">+ Бонус:</template>
                  <template slot="content">
                    <!-- <div class="date">24.01.22</div> -->
                    <p>1) Вебинар по бПИФ в России (17.01.22)</p>
                    <p>2) Прогноз: куда инвестировать в 2022 году (27.01.22)</p>
                  </template>
                </badger-accordion-item>
              </badger-accordion>
            </div>
          </div>
        </div>
      </div>

      <div class="stripe">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="break"></div>
              <div class="heading big">
                <h1>
                  Курс подойдет <span class="blurplee">любому</span> инвестору
                </h1>
              </div>
              <div class="break"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <h1 class="text-center">Новичкам, если</h1>

              <table class="points">
                <tbody>
                  <tr>
                    <td>👉</td>
                    <td>Вы только задумались об инвестициях</td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>Вам не хватает смелости начать инвестировать</td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>Вам кажется, что у Вас нет денег для инвестиций</td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>Вы хотите подготовиться к пенсии</td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>Вы не готовы брать лишний риск</td>
                  </tr>
                </tbody>
              </table>

              <!-- <ul class="learn">
                <li>Вы только задумались об инвестициях</li>
                <li>Вам не хватает смелости начать инвестировать</li>
                <li>Вам кажется, что у Вас нет денег для инвестиций</li>
                <li>Вы хотите подготовиться к пенсии</li>
                <li>Вы не готовы брать лишний риск</li>
              </ul> -->
              <div class="break25"></div>
            </div>
            <div class="col-md-6">
              <h1 class="text-center">Опытным, если</h1>

              <table class="points">
                <tbody>
                  <tr>
                    <td>👉</td>
                    <td>
                      У Вас уже есть инвестиционный портфель, но нет уверенности
                    </td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>
                      Вам нужен рациональный и просчитанный подход к составлению
                      портфеля
                    </td>
                  </tr>
                  <tr>
                    <td>👉</td>
                    <td>
                      Вы хотите проанализировать и ребалансировать имеющийся
                      портфель
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <ul class="learn">
                <li>
                  У Вас уже есть инвестиционный портфель, но нет уверенности
                </li>
                <li>
                  Вам нужен рациональный и просчитанный подход к составлению
                  портфеля
                </li>
                <li>
                  Вы хотите проанализировать и ребалансировать имеющийся
                  портфель
                </li>
              </ul> -->
            </div>
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="heading">
                    <h1>
                      Курс состоит из
                      <span class="blurplee">16</span> видео-уроков
                    </h1>
                  </div>
                  <p>
                    Уроки открываются по понедельникам и четвергам 08:00
                    согласно расписанию. Вы можете проходить их в своем темпе.
                    Каждый урок смонтирован и длится 20-30 минут, чтобы у Вас
                    точно нашлось время на его прохождение. В конце обучения Вас
                    ожидает завершающий живой вебинар, где Юлия Фанг разберет
                    два присланных портфеля, и любой участник сможет задать свои
                    вопросы.
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="heading">
                    <h1>
                      Только
                      <span class="blurplee">практическая</span> информация
                    </h1>
                  </div>
                  <p>
                    В курсе будет только практическая информация, необходимая
                    для составления портфеля и минимальное количество теории,
                    необходимой для восприятия информации. На каждом занятии Вы
                    будете получать ссылки на необходимые бесплатные сервисы и
                    рекомендации на интересные источники.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="bonus">
              <div class="heading">
                <h1>Бонус!</h1>
                <!-- <div class="break"></div> -->
              </div>
              <div class="row">
                <div class="break25"></div>
                <div class="col-md-12">
                  <div class="scene scene--card">
                    <div
                      class="card"
                      :class="{ flipped: flip }"
                      @click="flip = !flip"
                    >
                      <div class="card__face card__face--front"></div>
                      <div class="card__face card__face--back"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 text-center">
                <div class="comment">
                  <span :class="{ invis: !flip, vis: flip }"
                    >Супер полезный Excel файл для расчетов доходности и рисков
                    портфеля.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container" id="prices">
        <div class="row">
          <div class="col-md-12">
            <div class="heading">
              <h1>Цены</h1>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="pricebox">
                  <div>
                    <h3 class="text-center">“Самостоятельный”</h3>
                    <h2
                      class="text-center"
                      style="
                        font-size: 16px;
                        color: white;
                        background-color: #bc68e6;
                        border-radius: 6px;
                        padding: 8px;
                      "
                    >
                      Базовый <br />пакет
                    </h2>
                    <ul class="pricelist">
                      <li>Доступ ко всем видео</li>
                      <li>Excel таблицы</li>
                      <li>Выпускной вебинар</li>
                      <li>Чат (по регионам)</li>
                      <li>Отдельный канал с сообществом инвесторов</li>

                      <li>Выпускной</li>
                    </ul>
                    <!-- <div class="price text-center old">3,900 ₽</div> -->
                    <br />
                    <div class="price text-center">59 €</div>

                    <a
                      href="https://juliafang.com/course/etf-course/"
                      class="ybutton full"
                      >Купить</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="pricebox">
                  <div>
                    <h3 class="text-center">+ Дополнение 1</h3>
                    <h2
                      class="text-center"
                      style="
                        font-size: 16px;
                        color: white;
                        background-color: #bc68e6;
                        border-radius: 6px;
                        padding: 10px;
                      "
                    >
                      Индивидуальная работа <br />с куратором
                    </h2>

                    <ul class="pricelist">
                      <li>
                        <strong>
                          Опциональное дополнение к "Самостоятельному"
                          пакету</strong
                        >
                      </li>
                      <li><strong> Докупается отдельно</strong></li>
                    </ul>

                    <hr style="border-color: #d5c2ad" />
                    <ul class="pricelist">
                      <li>Проверка ДЗ</li>
                      <li>Проверка финального портфеля</li>
                      <!-- <li>Цена до 10.07.2021</li> -->
                    </ul>
                    <!-- <div class="price text-center old">+6,000 ₽</div> -->
                    <br />
                    <div class="price text-center">+65 €</div>
                    <a
                      href="https://juliafang.com/course/etf-course/"
                      class="ybutton full"
                      >Купить</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="pricebox">
                  <div>
                    <h3 class="text-center">+ Дополнение 2</h3>
                    <h2
                      class="text-center"
                      style="
                        font-size: 16px;
                        color: white;
                        background-color: #bc68e6;
                        border-radius: 6px;
                        padding: 8px;
                      "
                    >
                      Индивидуальная работа <br />с Юлией Фанг
                    </h2>

                    <ul class="pricelist">
                      <li>
                        <strong>
                          Опциональное дополнение к "Самостоятельному"
                          пакету</strong
                        >
                      </li>
                      <li><strong> Докупается отдельно</strong></li>
                    </ul>

                    <hr style="border-color: #d5c2ad" />

                    <ul class="pricelist">
                      <li>Проверка ДЗ</li>
                      <li>Проверка финального портфеля</li>
                      <li>Индивидуальная консультация с Юлией Фанг (1 час)</li>

                      <!-- <li>Цена до 10.07.2021</li> -->
                    </ul>
                    <!-- <div class="price text-center old">+6,000 ₽</div> -->
                    <br />
                    <div class="price text-center">+135 €</div>
                    <a
                      href="https://juliafang.com/course/etf-course/"
                      class="ybutton full"
                      >Купить</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container" id="about">
        <div class="row">
          <div class="col-md-12">
            <div class="heading">
              <h1><span class="blurple">Юлия</span>, очень приятно</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="avatar-holdert">
              <img class="avatar" src="./assets/JuliaFang.png" alt="" />
            </div>
          </div>
          <div class="col-md-8">
            <div class="break40"></div>
            <p>Знакомьтесь, Юлия, ваш преподаватель.</p>
            <p>Юлия Фанг является частным инвестором с 2002 года.</p>
            <p>
              С 2005 года работает в инвестиционном банкинге и private equity
              (специалист по глобальным фондам, бизнес и финансовый аналитик,
              инвестиционный управляющий).
            </p>
            <p>
              2009-2018 Юлия проживала на Тайване, где получила MBA (Southern
              Taiwan University of Science and Technology) и основала
              Европейскую Бизнес Ассоциацию.
            </p>
            <p>
              С 2020 года Юлия Фанг имеет более 2000 учеников на таких успешных
              курсах как “Автоматический Миллионер” и “Дивидендная Фабрика”.
            </p>
            <p>Юлия является членом CFA Institute и CFA Society Taiwan.</p>
            <p>CFA Level 2 candidate</p>
            <div class="break25">
              <div class="links">
                <a href="https://juliafang.com">Вебсайт</a> -
                <a href="https://www.instagram.com/juliafang_school/?hl=ru"
                  >Instagram</a
                >
                - <a href="https://investorama.fm/">Подкаст</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="break"></div>
  </div>
</template>

<script>
import calc from "./utils/calc.js";
import bars from "./utils/bars.js";
import etfs_list from "./utils/etfs.js";

import VueApexCharts from "vue-apexcharts";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";

export default {
  name: "App",
  components: {
    apexchart: VueApexCharts,
    BadgerAccordion,
    BadgerAccordionItem,
  },
  data() {
    return {
      activeItem: 0,
      items: [
        {
          name: "Биотехнологии",
          series: [30, 25, 19, 10, 9, 7],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Biogen",
              "Gilead Sciences",
              "Moderna",
              "Amgen",
              "Illumina",
              "Merck",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Зеленая энергетика",
          series: [44, 55, 13, 43, 22, 30],

          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "NextEra Energy",
              "First Solar",
              "Tesla",
              "Nio",
              "Canadian Solar",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Космос",
          series: [40, 31, 20, 7, 4, 2],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Boeing",
              "Virgin Galactic",
              "Lockheed Martin",
              "Raytheon Technologies",
              "Illumina",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Видео игры",
          series: [30, 29, 23, 20, 19, 18],

          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "NVIDIA",
              "AMD",
              "Tencent",
              "Roblox",
              "Activision Blizzard",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Электрокары",
          series: [80, 71, 70, 50, 40, 30],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Tesla",
              "Hyundai Motor",
              "Volkswagen",
              "Honda Motor",
              "Cisco",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Полупроводники",
          series: [10, 9, 5, 3, 2, 2],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Broadcom",
              "TSMC",
              "Qualcomm",
              "Intel",
              "NVIDIA",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Каннабис",
          series: [20, 19, 18, 5, 5, 5],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Tilray",
              "Cronos",
              "Aurora Cannabis",
              "Organifarm Holdings",
              "Canopy Growth",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Финтех",
          series: [30, 29, 25, 8, 3, 3],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Square",
              "Shopify",
              "Paypal",
              "Coinbase",
              "Mercado Libre",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          name: "Недвижимость",
          series: [50, 35, 30, 10, 5, 1],
          chartOptions: {
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "Public Storage",
              "Duke Realty",
              "Welltower",
              "Prologis",
              "Life Storage",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },

        {
          name: "Кибербезопасность",
          series: [100, 75, 75, 60, 20, 10],
          chartOptions: {
            legend: {
              position: "bottom",
            },
            chart: {
              width: 500,
              type: "pie",
            },
            labels: [
              "CrowdStrike",
              "Okta",
              "Accenture",
              "Zscaler",
              "CyberArk",
              "Остальное",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          },
        },
      ],

      flip: false,
      sum: 100,
      years: 15,
      percent: 12,
      etfs: etfs_list,
    };
  },
  computed: {
    result: function () {
      // console.log();
      return parseInt(calc(this.sum, this.years, this.percent));
    },

    getbars: function () {
      let bars_result = bars(this.sum, this.years, this.percent);

      return bars_result.series;
    },

    getopts: function () {
      let bars_result = bars(this.sum, this.years, this.percent);
      return bars_result.chartOptions;
    },

    intres: function () {
      //return this.result.toFixed(2);
      let i = this.result - this.sum * this.years * 12;
      //return i.toFixed(2);
      return i;
    },
  },
  methods: {
    selectItem(i) {
      console.log("hit:" + i);
      this.activeItem = i;
    },
  },
  mounted() {
    calc();
  },
};
</script>

<style lang="scss">
#app {
}
</style>
